import moment from "moment-timezone";
import { theme } from "../../../../config/style-configs/theme";

const formatShiftWindow = (shift, timezone) => {
  const resolvedTimezone = timezone || "UTC";
  const start =
    shift && shift.execStartTime
      ? moment(shift.execStartTime).tz(resolvedTimezone)
      : null;
  const end =
    shift && shift.execEndTime
      ? moment(shift.execEndTime).tz(resolvedTimezone)
      : null;

  if (!end) return "Completed time unavailable";
  if (!start) return end.format("YYYY-MM-DD h:mm A");
  if (start.isSame(end, "day")) {
    return `${start.format("YYYY-MM-DD h:mm A")} - ${end.format("h:mm A")}`;
  }
  return `${start.format("YYYY-MM-DD h:mm A")} - ${end.format(
    "YYYY-MM-DD h:mm A"
  )}`;
};

export const missedCompletedShiftAssignmentConfirmationHtml = data => `<div style="box-sizing: border-box; padding: 15px; white-space: pre-wrap; font-size: ${
  theme.FONT_SIZE_MEDIUM
}px; font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', sans-serif">
<div style="margin-bottom: 8px; color: ${
  theme.color
}">Please confirm the following completed Shifts will be assigned to Timesheets:</div>
${data
  .map(
    careCircle => `<span>Care Circle ${
      careCircle.displayName
    } <span style="font-size: ${theme.FONT_SIZE_TINY}px">(ID: ${
      careCircle.groupId
    })</span> has <b>${
      careCircle.shifts.length
    }</b> completed Shifts ready to be assigned:</span>
<ul>${careCircle.shifts
      .map(
        shift =>
          `<li>${formatShiftWindow(
            shift,
            careCircle.timezone
          )}: <b>${shift.caregiverName ||
            "Caregiver"}</b>&nbsp;&nbsp;<span style="font-size: ${
            theme.FONT_SIZE_TINY
          }px">(Shift ID: ${shift.shiftId})</span></li>`
      )
      .join("")}</ul>`
  )
  .join("")}
</div>`;
